import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    chartEditorAddAccountBodySchema,
    chartEditorAddAccountResponseSchema,
    chartEditorAddGroupBodySchema,
    chartEditorDeleteBodySchema,
    chartEditorMoveBodySchema,
    chartEditorRenameGroupBodySchema,
    chartEditorSetAccountDisabledBodySchema,
    chartEditorUpdateAccountBodySchema,
} from "@common/schemas/domains/accounting/chart-editor.schema";

const c = initContract();

const pathParams = z.object({ workspaceId: z.string().uuid() });

// Concurrent-edit and validation refusals are 400 here, matching the bulk
// account operations rather than the platform API's 409.
const mutationResponses = {
    400: ErrorMessageSchema,
    403: ErrorMessageSchema,
    404: ErrorMessageSchema,
};

// One transaction per operation, spanning every business behind the edited row.
export const chartEditorContract = c.router(
    {
        updateAccount: {
            method: "POST",
            path: "/:workspaceId/account/update",
            pathParams,
            body: chartEditorUpdateAccountBodySchema,
            responses: { 200: z.void(), ...mutationResponses },
        },
        addAccount: {
            method: "POST",
            path: "/:workspaceId/account/add",
            pathParams,
            body: chartEditorAddAccountBodySchema,
            responses: {
                200: chartEditorAddAccountResponseSchema,
                ...mutationResponses,
            },
        },
        addGroup: {
            method: "POST",
            path: "/:workspaceId/group/add",
            pathParams,
            body: chartEditorAddGroupBodySchema,
            responses: { 200: z.void(), ...mutationResponses },
        },
        renameGroup: {
            method: "POST",
            path: "/:workspaceId/group/rename",
            pathParams,
            body: chartEditorRenameGroupBodySchema,
            responses: { 200: z.void(), ...mutationResponses },
        },
        deleteRows: {
            method: "POST",
            path: "/:workspaceId/delete",
            pathParams,
            body: chartEditorDeleteBodySchema,
            responses: { 200: z.void(), ...mutationResponses },
        },
        setAccountDisabled: {
            method: "POST",
            path: "/:workspaceId/account/disabled",
            pathParams,
            body: chartEditorSetAccountDisabledBodySchema,
            responses: { 200: z.void(), ...mutationResponses },
        },
        move: {
            method: "POST",
            path: "/:workspaceId/move",
            pathParams,
            body: chartEditorMoveBodySchema,
            responses: { 200: z.void(), ...mutationResponses },
        },
    },
    {
        pathPrefix: "/accounting/chart-editor",
    },
);
